import React from "react";
import "./styles/ManageFaCul.css";

function ManageFaCul() {
  return (
    <div className="container-managefacul">
      <div className="title-managefacul">
        <h1 className="tilte-manage-facul">La FACul</h1>
      </div>
      <div className="subtilte-managefacul">
        <h3 className="subtilte-manage-facul">Ajouter une question/réponse</h3>
      </div>
    </div>
  );
}

export default ManageFaCul;
